import { Card, Space } from "antd";
import React from "react";
import AgreementTab from "../AgreementTab";
import CompanyTab from "../CompanyTab";
import CompanyUserTab from "../CompanyUserTab";
import SurveyTemplateTab from "../SurveyTemplateTab";

export default function AdminDashboardPage() {
  return (
    <div style={{ display: "flex", gap: 20, padding: 20, flexDirection: "column" }}>

    <Space
      direction="vertical"
      size="large"
      style={{ width: "100%" }}
    >
      <Card bordered={false}>
        <CompanyTab />
      </Card>

      <Card bordered={false}>
        <CompanyUserTab />
      </Card>

      <Card bordered={false}>
        <SurveyTemplateTab />
      </Card>

      <Card bordered={false}>
        <AgreementTab />
      </Card>
    </Space>

    </div>
  );
}
